export default "__VITE_ASSET__BsJEhuNU__"